// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
	padding-top: 3rem;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
		"Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
		sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

code {
	font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
		monospace;
}

.no-border:not(.form-validated .is-valid, .form-validated .is-invalid) {
	border: 0 !important;
}

.form-validated .valid-feedback,
.form-validated .invalid-feedback {
	display: revert !important;
}

.form-validated .is-valid,
.form-validated .is-inavlid {
	padding-right: revert;
	background-image: revert;
}

.form-switch {
	place-content: center;
}

.grecaptcha-badge {
	visibility: hidden !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,iBAAiB;CACjB;;YAEW;CACX,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC;WACU;AACX;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;CAEC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;AAC9B","sourcesContent":["body {\n\tmargin: 0;\n\tpadding-top: 3rem;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n\t\t\"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n\t\tmonospace;\n}\n\n.no-border:not(.form-validated .is-valid, .form-validated .is-invalid) {\n\tborder: 0 !important;\n}\n\n.form-validated .valid-feedback,\n.form-validated .invalid-feedback {\n\tdisplay: revert !important;\n}\n\n.form-validated .is-valid,\n.form-validated .is-inavlid {\n\tpadding-right: revert;\n\tbackground-image: revert;\n}\n\n.form-switch {\n\tplace-content: center;\n}\n\n.grecaptcha-badge {\n\tvisibility: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
